import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import CompaniesTable from "./CompaniesTable"
import { useTranslation } from "react-i18next"

export default function CompaniesList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Companies")} />
        <CompaniesTable />
      </div>
    </div>
  )
}
